import Vue from 'vue'
import Router from 'vue-router'

import HomeLayout from '@/components/HomeLayout.vue'
import Login from '@/components/Login.vue'
import Dashboard from '@/components/Dashboard.vue'
import FormularioSeguro from './components/FormularioSeguro.vue'
import Personal from './components/Personal.vue'
import Empresariales from './components/Empresariales.vue'
import Nosotros from './components/Nosotros.vue'
import ListaProspectos from './components/ListaProspectos.vue'
import EditarPerfil from './components/EditarPerfil.vue'
import Administradores from './components/Administradores.vue'
import BlogList from './components/BlogList.vue'
import BlogDetalle from './components/BlogDetalle.vue'
import AdminBlogForm from './components/AdminBlogForm.vue'
import Servicion_bienes from './components/servicion_bienes.vue'
import Terminos_condiciones from './components/TerminosCondiciones.vue'



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeLayout
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/formulario_contacto',
      name: 'formulario',
      component: FormularioSeguro
    },
    {
      path: '/servicio_personal',
      name: 'personal',
      component: Personal
    },
    {
      path: '/servicio_bienes',
      name: 'bienes',
      component: Servicion_bienes
    },
    {
      path: '/servicio_empresarial',
      name: 'empresarial',
      component: Empresariales
    },
    {
      path: '/sobre_nosotros',
      name: 'nosotros',
      component: Nosotros
    },
    {
      path: '/listado_prospectos',
      name: 'prospectos',
      component: ListaProspectos
    },
    {
      path: '/editar_perfil',
      name: 'perfil',
      component: EditarPerfil
    },
    {
      path: '/administradores',
      name: 'administrador',
      component: Administradores
    },
    {
      path: '/blog',
      name: 'blog',
      component: BlogList
    },
    {
      path: '/blog/:slug',
      name: 'blog',
      component: BlogDetalle
    },
    {
      path: '/admin/blogs/create',
      name: 'blog',
      component: AdminBlogForm
    },
    {
      path: '/terminos-condiciones',
      name: 'terminos',
      component: Terminos_condiciones
    }
    
  ]
})